import Axios from 'axios'
import AuthService from '@/assets/services/AuthService'
import { setCookie } from '@/assets/helpers/UtilHelper'
const AUTH_ACCESS_TOKEN_KEY = process.env.VUE_APP_AUTH_ACCESS_TOKEN_KEY
const AUTH_LOGIN = 'AUTH_LOGIN'
const AUTH_LOGOUT = 'AUTH_LOGOUT'
const AUTH_REGISTER = 'AUTH_REGISTER'
const AUTH_TOKEN = 'AUTH_TOKEN'

const AUTH_REQUEST = 'AUTH_REQUEST'
const AUTH_REQUEST_ERROR = 'AUTH_REQUEST_ERROR'
const AUTH_REQUEST_SUCCESS = 'AUTH_REQUEST_SUCCESS'

const USER_REQUEST = 'USER_REQUEST'
const USER_CLEAR = 'USER_CLEAR'

const state = {
  token: '',
  status: ''
}

const getters = {
}

const mutations = {
  [AUTH_REQUEST]: state => {
    state.status = 'pending'
  },
  [AUTH_REQUEST_SUCCESS]: (state, token) => {
    state.status = 'success'
    state.token = token
    state.hasLoadedOnce = true
  },
  [AUTH_REQUEST_ERROR]: state => {
    state.status = 'error'
    state.token = ''
  },
  [AUTH_LOGOUT]: state => {
    state.token = ''
  }
}

const actions = {
  [AUTH_TOKEN]: ({ commit, dispatch }, token) => {
    return new Promise((resolve, reject) => {
      dispatch(USER_REQUEST, token)
      resolve()
    })
  },
  [AUTH_LOGIN]: async ({ commit, dispatch }, params) => {
    const response = await AuthService.login(params)
    if (response && response.status === 201) {
      const token = response.data.token
      window.localStorage.setItem(AUTH_ACCESS_TOKEN_KEY, token)
      Axios.defaults.headers.common['Authorization'] = token
      commit(AUTH_REQUEST_SUCCESS, token)
      dispatch(USER_REQUEST, token)
      return response.data
    } else if (response && response.status === 422) {
      window.localStorage.removeItem(AUTH_ACCESS_TOKEN_KEY)
      commit(AUTH_REQUEST_ERROR)
      // check error msg
      return response.data
    } else {
      return null
    }
  },
  [AUTH_LOGOUT]: async ({ commit, dispatch }) => {
    const response = await AuthService.logout()
    if (response && response.status === 204) {
      window.localStorage.removeItem(AUTH_ACCESS_TOKEN_KEY)
      commit(AUTH_LOGOUT)
      commit(USER_CLEAR)
      return true
    } else {
      if (response.status === 401) {
        //
      }
      window.localStorage.removeItem(AUTH_ACCESS_TOKEN_KEY)
      commit(AUTH_LOGOUT)
      return false
    }
  },
  [AUTH_REGISTER]: async ({ commit, dispatch }, params) => {
    const response = await AuthService.register(params)
    if (response && response.status === 201) {
      // Save cookies from localStorage
      const token = window.localStorage.getItem(AUTH_ACCESS_TOKEN_KEY)
      const date = new Date()
      date.setMonth(date.getMonth() + 1)
      const expires = date
      setCookie('token', token, expires, '.muzikair.com')
      return response.data
    } else if (response && response.status === 422) {
      // check error msg
      return response.data
    } else {
      return null
    }
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}
